/**
 * Interfeys tili: uz (manba matnlar) / ru / en.
 * Demo bilan bir xil: kalit — o'zbekcha matn; `#` — son, `*` — ixtiyoriy parcha;
 * tarjimada `$1` — o'sha parcha, `@1` — parchaning tarjimasi; `{bir|ko'p}` yoki `{1|2-4|5+}` — ko'plik.
 */
import dictJson from './dict.json';
import type { UiLang } from '../data/types';
import { api, hasToken } from '../lib/api';

const DICT = dictJson as Record<'ru' | 'en', Record<string, string>>;
export const UI_KEY = 'lexo-v2-ui';

export function readUiLang(): UiLang {
  try { const v = localStorage.getItem(UI_KEY); return v === 'ru' || v === 'en' ? v : 'uz'; } catch { return 'uz'; }
}
export const UI: UiLang = readUiLang();
export function setUiLang(v: UiLang) {
  try { localStorage.setItem(UI_KEY, v); } catch { /* ignore */ }
  const p = hasToken() ? api.patch('/v1/me', { ui_lang: v }).catch(() => {}) : Promise.resolve();
  p.finally(() => location.reload());
}

const TRD: Record<string, string> | null = UI === 'uz' ? null : DICT[UI];
export const CONFIRM_WORD = { uz: 'TOZALASH', ru: 'УДАЛИТЬ', en: 'DELETE' }[UI];

function plural(s: string): string {
  return s.replace(/(\d+(?:[  ]\d{3})*)(\s*)\{([^{}|]+)\|([^{}|]+)(?:\|([^{}|]+))?\}/g, (_m, n: string, sp: string, a: string, b: string, c?: string) => {
    const k = +n.replace(/\D/g, '');
    let f: string;
    if (c !== undefined) { const d = k % 10, h = k % 100; f = (d === 1 && h !== 11) ? a : (d >= 2 && d <= 4 && (h < 12 || h > 14)) ? b : c; }
    else f = k === 1 ? a : b;
    return n + sp + f;
  });
}

let TRP: Array<[RegExp, string]> | null = null;

/** Matnni joriy interfeys tiliga o'giradi. uz'da o'zgarishsiz qaytaradi. */
export function t(s: string): string {
  if (!TRD || !s) return s;
  const v = TRD[s];
  if (v !== undefined) return plural(v);
  if (!TRP) {
    TRP = Object.keys(TRD).filter((k) => /[#*]/.test(k))
      .sort((a, b) => b.replace(/[#*]/g, '').length - a.replace(/[#*]/g, '').length)
      .map((k) => [new RegExp('^' + k.replace(/[.+?^${}()|[\]\\]/g, '\\$&').replace(/\*/g, '(.+?)').replace(/#/g, '(\\d+(?:[ \\u00a0]\\d{3})*)') + '$'), TRD[k]!]);
  }
  for (const [re, val] of TRP) {
    const m = s.match(re);
    if (m) return plural(val.replace(/([$@])(\d)/g, (_x, ty: string, i: string) => (ty === '$' ? m[+i]! : t(m[+i]!))));
  }
  return s;
}

/** Sonli matn uchun qulaylik: t('# ta soʻz', 5) → "5 ta soʻz" (uz) / "5 слов" (ru). */
export function tn(template: string, ...nums: Array<number | string>): string {
  let i = 0;
  return t(template.replace(/#/g, () => String(nums[i++] ?? '')));
}

export const UI_LANGS: Array<[UiLang, string]> = [['uz', 'Oʻzbekcha'], ['ru', 'Русский'], ['en', 'English']];
